import { render } from "./TaskDropZone.vue?vue&type=template&id=1fc9b73c&scoped=true"
import script from "./TaskDropZone.vue?vue&type=script&lang=js"
export * from "./TaskDropZone.vue?vue&type=script&lang=js"

import "./TaskDropZone.vue?vue&type=style&index=0&id=1fc9b73c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc9b73c"]])

export default __exports__